export default class MoveTopPager {
  /**
   * @type {HTMLElement}
   * @readonly
   */
  elTopPager = document.querySelector('.comments__top-pager');
  /**
   * @type {HTMLElement}
   * @readonly
   */
  elOriginalPostElement = document.querySelector('.block-system-main-block');

  constructor() {
    if (this.elTopPager === null || this.elOriginalPostElement === null) {
      return;
    }

    // Place the top pager above the original post-element
    this.elOriginalPostElement.insertAdjacentElement('beforebegin', this.elTopPager);
    this.elTopPager.classList.add('comments__top-pager--moved');
  }
}
